import {
  IFormFieldData,
  IFormFieldOptionTodoData,
  IFormFieldOptionTodoTemplateData,
  IFormTemplateData
} from '@/models';
import { AxiosInstance } from 'axios';
import {
  IFetchFormFieldOptionTodosParams,
  IFetchFormFieldParams,
  IFetchFormTemplatesParams,
  IFormTemplateService,
  IUpdateFormTemplateStatePayload
} from './form-template.types';

export class FormTemplateService implements IFormTemplateService {
  private endpoint: string;

  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/forms/';
  }

  fetchFormTemplates(
    params?: IFetchFormTemplatesParams
  ): Promise<IFormTemplateData[]> {
    return this.axios
      .get<IFormTemplateData[]>(`${this.endpoint}templates/`, {
        params: params
      })
      .then(({ data }) => data);
  }

  fetchFormTemplate(id: number): Promise<IFormTemplateData> {
    return this.axios
      .get<IFormTemplateData>(`${this.endpoint}templates/${id}/`)
      .then(({ data }) => data);
  }

  createFormTemplate(data: IFormTemplateData): Promise<IFormTemplateData> {
    return this.axios
      .post<IFormTemplateData>(`${this.endpoint}templates/`, data)
      .then(({ data }) => data);
  }

  updateFormTemplate(data: IFormTemplateData): Promise<IFormTemplateData> {
    return this.axios
      .patch<IFormTemplateData>(`${this.endpoint}templates/${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteFormTemplate(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}templates/${id}/`);
  }

  updateFormTemplateState(
    data: IUpdateFormTemplateStatePayload
  ): Promise<IFormTemplateData> {
    return this.axios
      .put<IFormTemplateData>(
        `${this.endpoint}templates/${data.id}/set-state/${data.state}/`
      )
      .then(({ data }) => data);
  }

  //fields
  fetchFormFields(params: IFetchFormFieldParams): Promise<IFormFieldData[]> {
    return this.axios
      .get<IFormFieldData[]>(`${this.endpoint}fields/`, {
        params: params
      })
      .then(({ data }) => data);
  }

  fetchFormField(id: number): Promise<IFormFieldData> {
    return this.axios
      .get<IFormFieldData>(`${this.endpoint}fields/${id}/`)
      .then(({ data }) => data);
  }

  createFormField(data: IFormFieldData): Promise<IFormFieldData> {
    return this.axios
      .post<IFormFieldData>(`${this.endpoint}fields/`, data)
      .then(({ data }) => data);
  }

  updateFormField(data: IFormFieldData): Promise<IFormFieldData> {
    return this.axios
      .patch<IFormFieldData>(`${this.endpoint}fields/${data.id}/`, data)
      .then(({ data }) => data);
  }

  deleteFormField(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}fields/${id}/`);
  }

  //todos
  fetchFormFieldOptionTodos(
    params: IFetchFormFieldOptionTodosParams
  ): Promise<IFormFieldOptionTodoData[]> {
    return this.axios
      .get<IFormFieldOptionTodoData[]>(
        `${this.endpoint}templates/${params.templateId}/todos/`,
        {
          params: {
            section_field: params.sectionFieldId,
            field_option: params.fieldOptionId
          }
        }
      )
      .then(({ data }) => data);
  }

  createFormFieldOptionTodo(
    params: IFetchFormFieldOptionTodosParams,
    data: IFormFieldOptionTodoData
  ): Promise<IFormFieldOptionTodoData> {
    return this.axios
      .post<IFormFieldOptionTodoData>(
        `${this.endpoint}templates/${params.templateId}/todos/`,
        data
      )
      .then(({ data }) => data);
  }

  updateFormFieldOptionTodo(
    params: IFetchFormFieldOptionTodosParams,
    data: IFormFieldOptionTodoData
  ): Promise<IFormFieldOptionTodoData> {
    return this.axios
      .patch<IFormFieldOptionTodoData>(
        `${this.endpoint}templates/${params.templateId}/todos/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }

  deleteFormFieldOptionTodo(
    params: IFetchFormFieldOptionTodosParams,
    id: number
  ): Promise<any> {
    return this.axios.delete(
      `${this.endpoint}templates/${params.templateId}/todos/${id}/`
    );
  }

  //todo template
  fetchFormTodoTemplates(): Promise<IFormFieldOptionTodoTemplateData[]> {
    return this.axios
      .get<IFormFieldOptionTodoTemplateData[]>(
        `${this.endpoint}todo-templates/`
      )
      .then(({ data }) => data);
  }
  fetchFormTodoTemplate(id: number): Promise<IFormFieldOptionTodoTemplateData> {
    return this.axios
      .get<IFormFieldOptionTodoTemplateData>(
        `${this.endpoint}todo-templates/${id}/`
      )
      .then(({ data }) => data);
  }
  createFormTodoTemplate(
    data: IFormFieldOptionTodoTemplateData
  ): Promise<IFormFieldOptionTodoTemplateData> {
    return this.axios
      .post<IFormFieldOptionTodoTemplateData>(
        `${this.endpoint}todo-templates/`,
        data
      )
      .then(({ data }) => data);
  }
  updateFormTodoTemplate(
    data: IFormFieldOptionTodoTemplateData
  ): Promise<IFormFieldOptionTodoTemplateData> {
    return this.axios
      .patch<IFormFieldOptionTodoTemplateData>(
        `${this.endpoint}todo-templates/${data.id}/`,
        data
      )
      .then(({ data }) => data);
  }
  deleteFormTodoTemplate(id: number): Promise<any> {
    return this.axios.delete(`${this.endpoint}todo-templates/${id}/`);
  }
}
